'use client';

import * as sessionReplay from '@amplitude/session-replay-browser';

import { getLeiaDeviceId } from '@/utils/leiaClientSide';
import { noticeError } from '@/utils/newrelicHelpers';

/**
 * Initialize Amplitude Session Replay
 * This should be called once the page loads and analytics are ready
 */
export async function initAmplitudeSessionReplay(
  apiKey: string,
  sampleRate: number,
): Promise<void> {
  const deviceId = getLeiaDeviceId();
  const sessionId = window.rudderanalytics?.getSessionId?.();

  if (!deviceId || !sessionId) {
    return;
  }

  try {
    await sessionReplay.init(apiKey, {
      deviceId,
      sessionId,
      sampleRate,
      debugMode: process.env.NODE_ENV === 'development',
    }).promise;
  } catch (error) {
    noticeError(
      'Failed to initialize Amplitude Session Replay',
      error instanceof Error ? error.message : String(error),
    );
  }
}
